import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CampaignDTO, CommercialDTO, RequirementDTO } from '../../services/api/api';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'sb-targeting-preview',
  templateUrl: './sb-targeting-preview.component.html',
  styleUrls: ['./sb-targeting-preview.component.scss'],
  animations: [
    trigger('smoothCollapse', [
      state(
        'initial',
        style({
          height: '0',
          overflow: 'hidden',
          opacity: '0',
          'padding-top': '0',
          'padding-bottom': '0',
        })
      ),
      state(
        'final',
        style({
          overflow: 'hidden',
          opacity: '1',
        })
      ),
      transition('initial=>final', animate('200ms')),
      transition('final=>initial', animate('200ms')),
    ]),
  ],
  standalone: false,
})
export class SbTargetingPreviewComponent {
  @Input() campaignPreviewData: CampaignDTO;
  @Input() commercialPreviewData: CommercialDTO;
  @Input() requirementPreviewData: RequirementDTO;
  @Input() wizardPreviewState: string;
  @Output() changeWizardState = new EventEmitter<string>();
  @Input() isCollapsed: boolean;

  constructor(public translate: TranslateService) {}

  changeWizardPreviewState(str: string) {
    this.changeWizardState.emit(str);
  }
}
